import './utils/jquery';
import './polyfills/nodeListForEach';
import './polyfills/elementClosest';
import $script from 'scriptjs';

import flickityTouchFix from './helpers/FlickityTouchFix';

import 'intersection-observer';
import PxsMap from 'pxs-map';
import PxsVideo from 'pxs-video';
import rimg from '@pixelunion/rimg-shopify';
import ShopifySectionsManager from 'shopify-sections-manager';

// Sections
import Collection from './sections/Collection';
import DynamicPromotions from '../sections/dynamic-promotions/DynamicPromotions';
import DynamicSlideshow from '../sections/dynamic-slideshow/DynamicSlideshow';
import Product from './sections/Product';
import StaticAddresses from './sections/StaticAddresses';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticFooter from './sections/StaticFooter';
import StaticGiftCard from './sections/StaticGiftCard';
import StaticHeader from '../sections/static-header/StaticHeader';
import StaticPassword from './sections/StaticPassword';
import StaticProductRecommendations from './sections/StaticProductRecommendations';

// Components
import ProductList from './components/ProductList';
import Rte from './utils/Rte';
import Share from './components/Share';

const scripts = document.querySelector('[data-scripts]');

$script([scripts.dataset.shopifyApiUrl], () => {
  rimg.init();
  const sections = new ShopifySectionsManager();

  sections.register('dynamic-featured-collection', section => new Collection(section));
  sections.register('dynamic-featured-product', section => new Product(section));
  sections.register('dynamic-promotions', section => new DynamicPromotions(section));
  sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
  sections.register('pxs-map', section => new PxsMap(section));
  sections.register('pxs-video', section => new PxsVideo(section));
  sections.register('static-addresses', section => new StaticAddresses(section));
  sections.register('static-article', section => new Share(section));
  sections.register('static-blog', section => new StaticBlog(section));
  sections.register('static-cart', section => new StaticCart(section));
  sections.register('static-collection', section => new Collection(section));
  sections.register('static-footer', section => new StaticFooter(section));
  sections.register('static-gift-card', section => new StaticGiftCard(section));
  sections.register('static-header', section => new StaticHeader(section));
  sections.register('static-password', section => new StaticPassword(section));
  sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));
  sections.register('static-product', section => new Product(section));
  sections.register('static-search-results', section => new ProductList(section));

  document.querySelectorAll('[data-rich-text-area]').forEach(el => new Rte({ el }));

  flickityTouchFix();
});
